// Conversion des dates saisies dans le BO (DateInput → "YYYY-MM-DD") en
// epoch ms attendus par le backend, en heure de Paris (le métier est en
// France, indépendamment du fuseau du navigateur de l'admin).

export const PARIS_TZ = "Europe/Paris";

// Décalage (ms) du fuseau `timeZone` par rapport à UTC à l'instant `utcMs`.
const tzOffsetMs = (utcMs, timeZone) => {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const parts = {};
  dtf.formatToParts(new Date(utcMs)).forEach(({ type, value }) => {
    parts[type] = value;
  });
  const asUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour) % 24,
    Number(parts.minute),
    Number(parts.second)
  );
  return asUtc - (utcMs - (utcMs % 1000));
};

// "YYYY-MM-DD" → epoch ms du début (00:00:00.000) ou de la fin
// (23:59:59.999) de ce jour à Paris. Une valeur déjà numérique est
// renvoyée telle quelle ; une valeur illisible renvoie undefined.
export const parisDayToEpoch = (value, endOfDay = false) => {
  if (value == null || value === "") return undefined;
  if (typeof value === "number") return value;
  if (/^\d+$/.test(String(value))) return Number(value);
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return undefined;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const wall = endOfDay
    ? Date.UTC(y, mo - 1, d, 23, 59, 59, 999)
    : Date.UTC(y, mo - 1, d, 0, 0, 0, 0);
  // Deux passes pour tomber juste autour des changements d'heure.
  let guess = wall - tzOffsetMs(wall, PARIS_TZ);
  guess = wall - tzOffsetMs(guess, PARIS_TZ);
  return guess;
};
